import React from "react"
import { Box } from "src/UILibrary"
import { useTranslation } from "react-i18next"
import CheckBoxGroupField from "src/components/atom/CheckBoxGroupField"
import { useLoginContext } from "src/hooks/useLoginContext"
import { useMediaQuery } from "react-responsive"
import InputTextField from "src/components/atom/InputTextField"

type Props = {
  areaID: number[]
  handleAreaID: any
  keyword?: string
  handleKeyword?: any
}

export const UserSearchItem = ({ areaID, handleAreaID, keyword, handleKeyword }: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "mypage.user" })
  const isTablet = useMediaQuery({ query: "(min-width: 1200px)" })
  const { areas } = useLoginContext()

  return (
    <>
      {isTablet ? (
        <Box
          sx={{
            mt: "20px",
            mx: "0px",
            p: "10px 20px",
            bgcolor: "#F1F1F1",
          }}
        >
          <CheckBoxGroupField
            hasText
            name={t("register_area")}
            nameSize={14}
            datas={areas}
            labelSize={14}
            labelStyle={{ fontWeight: "400", fontFamily: "Noto Sans JP !important" }}
            lineSpace={0.5}
            selected={areaID}
            handleSelected={handleAreaID}
          />
          {handleKeyword && (
            <InputTextField
              text={keyword!}
              handleText={handleKeyword}
              name={t("name")}
              labelStyle={{
                fontSize: "14px",
                fontWeight: "400",
                fontFamily: "Noto Sans JP !important",
              }}
              sx={{ mt: "20px" }}
              placeholder={t("please_input_name")}
              inputStyle={{ width: "100%" }}
            />
          )}
        </Box>
      ) : (
        <>
          <Box>
            <CheckBoxGroupField
              hasText
              name={t("register_area")}
              nameSize={14}
              datas={areas}
              labelSize={14}
              labelStyle={{
                fontWeight: "400",
                fontFamily: "Noto Sans JP !important",
                pt: "10px!important",
              }}
              lineSpace={0.5}
              selected={areaID}
              handleSelected={handleAreaID}
              alignHorizontal={!isTablet}
              lineBreak
              noValidation
            />
          </Box>
        </>
      )}
    </>
  )
}
